import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import FormikInputField from '~/components/formikInputField/formikInputField';

export const getUnTanksQuery = gql`
  query tanks($breweryId: Int!) {
    tanks(breweryId: $breweryId, type: UNI_TANK) {
      id
      name
    }
  }
`;

export class UnTankDropdown extends Component {
  render() {
    const { name, brewery, className, value } = this.props;
    return (
      <Query query={getUnTanksQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <p className="ma0">Getting uni tanks</p>;
          }

          if (error) {
            return <p className="ma0">Error getting uni tanks</p>;
          }

          return (
            <FormikInputField type="select" name={name} className={className} value={value}>
              <option />
              {data.tanks.map(t => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </FormikInputField>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(UnTankDropdown);



// WEBPACK FOOTER //
// ./src/containers/uniTankDropdown/uniTankDropdown.jsx